import * as ActionConstants from "../constants/ReduxConstants";

export const manageStationList = (state = [], action) => {
  switch (action.type) {
    case ActionConstants.GET_MANAGE_STATION_LIST:
      return action.data;

    default:
      return state;
  }
};
